import gql from 'graphql-tag';

export default gql`
  mutation EditHba1cMeasurementMutation($request: HbA1cTestEditInputType!) {
    diabetes {
      HbA1cTestEdit(testEditData: $request) {
        __typename
        ... on BasicMutationSuccess {
          code
        }
        ... on UnauthorizedException {
          code
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;
